module.exports = __webpack_public_path__ + "img/bgcdash.ecc4d5ad.png";